import { axiosClient } from "@/shared/api/axios-client";
import type { Paginado, ProveedorCatalogo, SolicitudDetalle } from "@/lib/types";

export interface BuscarProveedoresParams {
  texto?: string;
  page?: number;
  pageSize?: number;
}

/**
 * P44 · FB60 Contrapago: selección de proveedor sin CFDI del que derivar el
 * RFC · picker con búsqueda server-side sobre el catálogo global activo.
 */
export const proveedorManualApi = {
  buscar: (params: BuscarProveedoresParams = {}) =>
    axiosClient
      .get<Paginado<ProveedorCatalogo>>("/api/solicitudes/proveedores/buscar", { params })
      .then((r) => r.data),
  seleccionar: (solicitudId: string, numeroProveedor: number) =>
    axiosClient
      .patch<SolicitudDetalle>(`/api/solicitudes/${solicitudId}/proveedor-manual`, {
        numeroProveedor,
      })
      .then((r) => r.data),
};
